import BaseResource from '@/lib/data/resource/BaseResource'

export default class ElectionVoterResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.Id = payload.Id ?? null
    this.Uid = payload.Uid ?? null
    this.Corps = payload.Corps ?? ''
    this.FirstName = payload.FirstName ?? ''
    this.LastName = payload.LastName ?? ''
    this.FullName = `${ payload.LastName } ${ payload.FirstName } ${ payload.FathersName ? `του ${ payload.FathersName }` : '' }`
    this.FathersName = payload.FathersName ?? ''
    this.Email = payload.Email ?? ''
    this.Phone = payload.Phone ?? ''
    this.IsOffline = payload.IsOffline ?? false
    this.Time = payload.Time ?? ''
  }

  /* PROPERTIES */

  /* METHODS */
}
